import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const DCCOFVA_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/dccofva/logo.png",
        alt: "Discovery Counseling & Consulting Logo",
        style: { width: "250px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 29,
  state: "VA",
  departmentIds: [170],
};
